import { StyledSpinner } from './styled';
import { SpinnerProp } from './types';

export const LoadingSpinner = ({ size = 25 }: SpinnerProp) => <StyledSpinner size={size} />;
